/**
 * Date utility functions for monthly calculations
 */

/**
 * Get the first day of the current month in YYYY-MM-DD format (UTC)
 */
export const getFirstDayOfCurrentMonth = (): string => {
  const now = new Date();
  // Use UTC methods to avoid timezone issues
  const firstDay = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  return firstDay.toISOString().split("T")[0];
};

/**
 * Get the last day of the current month in YYYY-MM-DD format (UTC)
 */
export const getLastDayOfCurrentMonth = (): string => {
  const now = new Date();
  // Use UTC methods to avoid timezone issues
  const lastDay = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 0));
  return lastDay.toISOString().split("T")[0];
};

/**
 * Get the first and last day of the current month
 */
export const getCurrentMonthRange = (): { start: string; end: string } => {
  return {
    start: getFirstDayOfCurrentMonth(),
    end: getLastDayOfCurrentMonth(),
  };
};

/**
 * Get the first and last day of a specific month/year (UTC)
 */
export const getMonthRange = (year: number, month: number): { start: string; end: string } => {
  const firstDay = new Date(Date.UTC(year, month - 1, 1));
  const lastDay = new Date(Date.UTC(year, month, 0));

  return {
    start: firstDay.toISOString().split("T")[0],
    end: lastDay.toISOString().split("T")[0],
  };
};

/**
 * Get the first and last day of the previous month (UTC)
 */
export const getPreviousMonthRange = (): { start: string; end: string } => {
  const now = new Date();
  // Calculate previous month: subtract 1 from current month (using UTC methods)
  const previousMonthDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1));
  const previousMonth = previousMonthDate.getUTCMonth() + 1; // Convert to 1-based
  const previousYear = previousMonthDate.getUTCFullYear();

  return getMonthRange(previousYear, previousMonth);
};

/**
 * Format date for display (DD/MM/YYYY)
 */
export const formatDateForDisplay = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("pt-BR");
};

/**
 * Get current month and year as string (e.g., "2025-07")
 */
export const getCurrentMonthYear = (): string => {
  const now = new Date();
  // Use UTC methods to avoid timezone issues
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
};
